import * as React from 'karet';

export const Loader = ({ className = '' }) => (
  <div>
    <img className={className} src="/images/ajax-loader.gif" alt="" />
  </div>
);
